const ACTION_RADIUS = 10;
const ACTION_FOCUS_RING_OFFSET = 6;
const ACTION_FOCUS_RING_WIDTH = ACTION_FOCUS_RING_OFFSET / 2;

export const tokens = {
    list: {
        wrapper: {
            padding: {
                bottom: 100,
            },
        },
        pagination: {
            margin: {
                top: 40,
            },
        },
    },
    item: {
        zIndex: {
            action: 1,
            interior: 2,
        },
        action: {
            radius: ACTION_RADIUS,
            focusRing: {
                width: ACTION_FOCUS_RING_WIDTH,
                offset: ACTION_FOCUS_RING_OFFSET,
                radius: ACTION_RADIUS + ACTION_FOCUS_RING_OFFSET,
            },
            activeRing: {
                width: ACTION_FOCUS_RING_OFFSET,
                offset: ACTION_FOCUS_RING_WIDTH - 1,
            },
        },
    },
};
